export const INVOICE_FOOTER_CHARACTER_LIMIT = 250
